// extracted by mini-css-extract-plugin
export default {"card":"select-cohort_card__Is2lL","cohort":"select-cohort_cohort__MRKFt","selected":"select-cohort_selected__S08ld"};